module.exports = __webpack_public_path__ + "static/fipcgreystar4-de137cbe1a5bf1467c4b56058307bb96.jpeg";